import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Button from 'components/common/Button';
import styles from 'pages/errors/NotFoundPage.module.css';

// Page d'attente affichée à la place d'un sous-site temporaire hors de ses dates d'ouverture.
const SubSiteComingSoonPage = ({ name }) => (
  <>
    <Helmet>
      <title>{`Ville d'Arras | ${name} - Prochainement`}</title>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="description" content={`Le site ${name} revient prochainement.`} />
      <meta property="og:title" content={`Ville d'Arras - ${name}`} />
      <meta property="og:description" content={`Le site ${name} revient prochainement.`} />
    </Helmet>
    <section className={`global-section ${styles.error}`}>
      <div className={`global-container ${styles.container}`}>
        <h1>Le site {name} revient prochainement.</h1>
        <Button variant="primary"><Link to="/">Retour à l'accueil</Link></Button>
      </div>
    </section>
  </>
);

SubSiteComingSoonPage.propTypes = {
  name: PropTypes.string.isRequired,
};

export default SubSiteComingSoonPage;
